<template>
  <!--visitSource:2 PC-->
  <div v-if="visitSource == 2" class="kw_ranking_list_pc">
    <div class="RankingBox_pc" :style="pageSetInfo.listStyleSet.listPageRankingBoxStyleSet?pageSetInfo.listStyleSet.listPageRankingBoxStyleSet.styleSetCode:''" kwName="listPageRankingBoxStyleSet">
      <div class="rankLine_pc" :style="pageSetInfo.listStyleSet.listPageRankingTopDecorateStyleSet?pageSetInfo.listStyleSet.listPageRankingTopDecorateStyleSet.styleSetCode:''" kwName="listPageRankingTopDecorateStyleSet">
        <div class="rankLineChild_pc"></div>
      </div>
      <div class="rankTable" style="padding:0 5px">
        <div class="rankItemTitle">
          <div>排行</div>
            <div v-for="(fieldInfo,fieldIndex) in listFieldSet" :key="fieldIndex">
              <div :style="fieldInfo.styleSet.listFieldNameStyleSet?fieldInfo.styleSet.listFieldNameStyleSet.styleSetCode:''" kwName="listFieldNameStyleSet">{{fieldInfo.fieldCnName}}</div>
            </div>
        </div>

        <div>
          <div v-for="(dataInfo,dataIndex) in dataList" :key="dataIndex">         
            <div class="rankItemText" style="padding: 5px 0">
              <div style="background: #FF9A1A;color: #fff;padding: 0 0;text-align: center;width: 45px;margin-left: 0;border-radius: 15px">{{dataIndex+1}}</div>
              <div v-for="(fieldInfo,fieldIndex) in listFieldSet" :key="fieldIndex">
                <div :style="fieldInfo.styleSet.listFieldValueStyleSet?fieldInfo.styleSet.listFieldValueStyleSet.styleSetCode:''" kwName="listFieldValueStyleSet">{{dataInfo[fieldInfo.fieldAliasName]}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




  <!--visitSource:3 h5-->
  <div v-else class="kw_ranking_list">
    <div class="RankingBox" :style="pageSetInfo.listStyleSet.listPageFieldStyleSet?pageSetInfo.listStyleSet.listPageFieldStyleSet.styleSetCode:''" kwName="listPageFieldStyleSet">
      <div class="rankLine" :style="pageSetInfo.listStyleSet.listPageRankingTopDecorateStyleSet?pageSetInfo.listStyleSet.listPageRankingTopDecorateStyleSet.styleSetCode:''" kwName="listPageRankingTopDecorateStyleSet">
        <div class="rankLineChild"></div>
      </div>
      <div class="rankTable" style="padding:0 5px">
        <div class="rankItemTitle">
          <div>排行</div>
            <div v-for="(fieldInfo,fieldIndex) in listFieldSet" :key="fieldIndex" >
              <div :style="fieldInfo.styleSet.listFieldNameStyleSet?fieldInfo.styleSet.listFieldNameStyleSet.styleSetCode:''" kwName="listFieldNameStyleSet">{{fieldInfo.fieldCnName}}</div>
            </div>
        </div>

        <div>
          <div v-for="(dataInfo,dataIndex) in dataList" :key="dataIndex">
            <div class="rankItemText">
              <div>{{dataIndex+1}}</div>
              <div v-for="(fieldInfo,fieldIndex) in listFieldSet" :key="fieldIndex">
                <div :style="fieldInfo.styleSet.listFieldValueStyleSet?fieldInfo.styleSet.listFieldValueStyleSet.styleSetCode:''" kwName="listFieldValueStyleSet">{{dataInfo[fieldInfo.fieldAliasName]}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

export default {
  name: 'kw_ranking_list',
  props: {
    pageSetInfo: {
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList: {
      type: Array,
      value: null
    },
    //单一一条数据进行显示
    dataInfo: {
      type: Object,
      value: null
    },
    initDataIndex: {
      type: Number,
      value: 0
    },
    previewVisitSource:{
      type:Number,
      default:0
    }
  },
  data() {
    var that = this;
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(that),
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
    /**
     * 列表数据点击时 进行跳转
     */
    listDataClick(dataInfo) {
      pageUtils.listDataClick(this, dataInfo);
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      pageUtils.dataButtonClick(this,detail,dataInfo);
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .kw_ranking_list_pc{}
.RankingBox{background: #F9BC2E;padding:0 15px 15px}
/*.RankingBox_pc{width: 96%;position: absolute;top:-5px;left: 2%;z-index: 1}*/
.RankingBox_pc{width: 96%;margin: 0 auto}
.rankLine{background: #FEDDAA;height: 18px;border-radius: 18px;display: flex;align-items: flex-end;}
.rankLine_pc{background: #FEDDAA;height: 20px;border-radius: 18px;display: flex;align-items: flex-end;}

.rankLineChild{margin: 0px 10px;border-top-left-radius: 10px;border-top-right-radius: 10px;height: 10px;background: #fff;width: 325px;}
.rankLineChild_pc{margin: 0px 10px;border-top-left-radius: 10px;border-top-right-radius: 10px;height: 10px;background: #fff;width: 100%;}
.rankTable{border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;margin: 0 5px}
.rankItemTitle{display: flex;justify-content: space-between;color: #6B6B6B;font-size: 16px;border-bottom: 1px solid #EFEFEF;padding: 15px 10px;}
.rankItemText{display: flex;justify-content: space-between;color: #9D9D9D;font-size: 15px;border-bottom: 1px solid #EFEFEF;padding: 25px 10px;margin: 0 10px}
.rankItemText div:nth-child(1),.rankItemTitle div:nth-child(1){width: 32px;text-align: center}
.rankItemText div:nth-child(2),.rankItemTitle div:nth-child(2){width: 32px;text-align: center}
.rankItemText div:nth-child(3),.rankItemTitle div:nth-child(3){width: 65px;text-align: center}
.rankItemText div:nth-child(4),.rankItemTitle div:nth-child(4){width: 65px;text-align: center}
.rankItemText div:nth-child(1){color: #656565}
.rankItemText div:nth-child(4){color: #F0450A}
</style>
